import { Context } from '@packages/layout/lib/UIShell/context';
import { createMemo } from '@packages/react';
import { useContext, useEffect } from 'react';

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: HideSidebar
 * @date:  12.10.2019
 * @time:  18:47
 */
export const HideSidebar = createMemo(
    () => {
        const [, { setDrawerHidden, setDrawer }] = useContext(Context);

        useEffect(() => {
            setDrawerHidden(true);
            setDrawer(false);
        }, ['']);

        return null;
    },
    {
        displayName: 'HideSidebar',
    },
);
